<template>
  <form
    @submit.prevent="onSubmit"
  >
    <div class="form-group">
      <label for="menu_model_selector_brand">
        Márka
      </label>
      <select
        id="menu_model_selector_brand"
        v-model="selectedMake"
        class="form-control form-control-sm"
      >
        <option :value="null"></option>
        <option
          v-for="make in makes"
          :key="'menu_model_selector_brand_' + make.id"
          :value="make"
        >
          {{ make.name }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="menu_model_selector_model">
        Modell
      </label>
      <select
        id="menu_model_selector_model"
        v-model="selectedModel"
        :disabled="!selectedMake"
        class="form-control form-control-sm"
      >
        <option></option>
        <option
          v-for="(model, index) in makeModels"
          :key="'menu_model_selector_brand_model_' + index"
          :value="model"
        >
          {{ model }}
        </option>
      </select>
    </div>
    <button
      :disabled="!selectedMake || !selectedModel"
      class="btn btn-block btn-primary mt-3"
    >
      Modell keresés
    </button>
  </form>
</template>

<script>
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';

  @Component
  export default class MenuModelSelector extends Vue {
    @Prop(Array) makes;
    @Prop(Object) models;

    selectedMake = null;
    selectedModel = null;

    get makeModels() {
      if (!this.selectedMake) {
        return [];
      }

      return this.models[this.selectedMake.name];
    }

    onSubmit() {
     window.location.href = this.selectedMake.url + '#' + this.selectedModel;
    }
  }
</script>
